import React from 'react';



import '../../Sales/Home.scss';



const WsServicingPage = (props: any) => {

  return (
    <div className="ws-sales-home-page">
      <div className="ws-sales-home-header">
        <h1>
          Workplace Servicing Platform
        </h1>
      </div>
    </div>
  );
};

export { WsServicingPage };
